import { EventResult, EventType } from "../../common/enums"
import Store from "../util/store"
import eventRegistry from "../../common/event-registry"
import protSender from "../util/protocol-sender"
import rtcEngine from '../rtc-engine'
import store from "../util/store"
import logger from "../../common/logger"

class OnlineManager {
  constructor() {
    // 全量用户数据可能会分页
    this.cachedUserList = null;

    // 注册消息处理函数
    Store.msgDispatcher.addMsgHandler(12120, this.onGetOnlineUsersRes.bind(this));
    Store.msgDispatcher.addMsgHandler(12123, this.onOnlineUsersNotify.bind(this));

    // 呼叫老协议
    Store.msgDispatcher.addMsgHandler(14001, this.onInviteRes.bind(this));
    Store.msgDispatcher.addMsgHandler(14002, this.onNotifyInvite.bind(this));
    Store.msgDispatcher.addMsgHandler(14004, this.onNotifyIgnoreInvite.bind(this));
    Store.msgDispatcher.addMsgHandler(14007, this.onCancelInviteRes.bind(this));
    Store.msgDispatcher.addMsgHandler(14008, this.onNotifyCancelInvite.bind(this));

    // 呼叫新协议
    Store.msgDispatcher.addMsgHandler(14301, this.onMakeCallRes.bind(this)); // 呼叫响应
    Store.msgDispatcher.addMsgHandler(14302, this.onMakeCallReq.bind(this)); // 收到呼叫
    Store.msgDispatcher.addMsgHandler(14304, this.onCallResult.bind(this)); // 呼叫结果
    Store.msgDispatcher.addMsgHandler(14305, this.onCallReleaseReq.bind(this)); // 拆线（被叫）
    Store.msgDispatcher.addMsgHandler(14308, this.onCancelCallRes.bind(this)); // 取消呼叫响应（主叫）
    Store.msgDispatcher.addMsgHandler(14309, this.onCancelCallReq.bind(this)); // 取消呼叫请求（被叫）
    Store.msgDispatcher.addMsgHandler(14312, this.onFinishCallRes.bind(this)); // 结束呼叫响应（主叫）
    Store.msgDispatcher.addMsgHandler(14313, this.onFinishCallReq.bind(this)); // 结束呼叫请求（被叫）
  }

  /**
   * 获取所有在线用户列表
   */
  getOnlineUsers() {
    protSender.sendGetOnlineUsersReq()
  };

  /**
   * 获取在线用户列表响应
   * @param {*} data 
   */
  onGetOnlineUsersRes(data) {
    if (data.result != 0) {
      eventRegistry.trigger(
        EventType.EVENT_GET_ONLINE_USERS, 
        EventResult.FAILED);
      return;
    }
    
    let pageInfo = {
      totalPages: data.page_info.total_pages,
      curPage: data.page_info.cur_page
    };
    
    let userInfo = [];
    for (const user of data.member_state_list) {
      let u = {
        userId: user.uid,
        onlineInfo: []
      };
  
      for (const info of user.online_info) {
        let state = {
          mutexType: info.mutex_type,
          customState: info.custom_state,
          state: info.state,
          extendInfo: info.extend_info
        };
        u.onlineInfo.push(state);
      }
  
      userInfo.push(u);
    }
  
    let params = {
      pageInfo: pageInfo,
      userInfo: userInfo
    };
  
    eventRegistry.trigger(
      EventType.EVENT_GET_ONLINE_USERS, 
      EventResult.SUCCESS, 
      params);

    this.cachedUserList = null;
  };

  /**
   * 邀请其他用户加入分组
   * @param {*} params 
   */
  invite(params) {
    let callees = [] // 转换userId->user_id
    for (const userId of params.calleeInfo) {
      callees.push({user_id: userId});
    }
    protSender.sendInviteReq(params, callees)
  };

  /**
   * 响应邀请
   * @param {*} params 
   */
  replyInvite(params) {
    protSender.sendInviteReply(params)
  };

  /**
   * 邀请方取消邀请协议
   * @param {*} params 
   */
  cancelInvite(params) {
    protSender.sendCancelReplyReq(params)
  };

  /**
   * 修改在线自定义状态
   * @param {*} params 
   */
  setCustomState(params) {
    if (typeof(params) !== 'string') {
      logger.error("setCustomState params should be string, params: " + params);
      return;
    }
    protSender.sendSetCustomStateReq(params)
  };

  /**
   * 增量在线用户推送
   * @param {*} data 
   */
  onOnlineUsersNotify(data) {
    let params = {
      userId: data.user_id,
      mutexType: data.mutex_type,
      state: data.operation,
      customState: data.custom_state,
      extendInfo: data.extend_info
    };
    eventRegistry.trigger("onOnlineUserState", params);
  };

  /**
   * 邀请响应
   * @param {*} data 
   */
  onInviteRes(data) {
    let params = {
      seqId: data.seq_id,
      userId: data.user_id,
      result: data.result
    };
    eventRegistry.trigger("onInviteReply", params);
  };

  /**
   * 服务器通知被邀请者
   * @param {*} data 
   */
  onNotifyInvite(data) {
    let params = {
      seqId: data.seq_id,
      groupId: data.group_id,
      userId: data.user_id,
      userName: data.user_name,
      extendInfo: data.extend_info
    };
    eventRegistry.trigger("onCommingInvite", params);
  };

  /**
   * 服务器通知被邀请者忽略邀请
   * @param {*} data 
   */
  onNotifyIgnoreInvite(data) {
    let params = {
      groupId: data.group_id,
      userId: data.user_id,
      userName: data.user_name
    };
    eventRegistry.trigger(EventType.EVENT_NOTICE_IGNORE_INVITE, params);
  };

  /**
   * 取消邀请响应
   * @param {*} data 
   */
  onCancelInviteRes(data) {
    let result = data.result;
    let params = {
      seqId: data.seq_id,
      userId: data.user_id,
    };
    eventRegistry.trigger(EventType.EVENT_CANCEL_INVITE, result, params);
  };

  /**
   * 服务器通知取消邀请
   * @param {*} data 
   */
  onNotifyCancelInvite(data) {
    let params = {
      seqId: data.seq_id,
      userId: data.user_id,
    };
    eventRegistry.trigger(EventType.EVENT_NOTICE_CANCEL_INVITE, 0, params);
  };

  //////////////////////////////////// 新的呼叫协议 ////////////////////////////////////

  /**
   * 呼叫
   * @param {*} params 
   */
  makeCall(params) {
    protSender.sendMakeCallReq(params);
  };

  /**
   * 取消呼叫
   * @param {*} params 
   */
  cancelCall(callId) {
    protSender.sendCancelCallReq(callId);
  };

  /**
   * 结束呼叫
   * @param {*} params 
   */
  finishCall(callId) {
    protSender.sendFinishCallReq(callId);
  };

  /**
   * 响应呼叫
   * @param {*} params 
   */
  replyMakeCall(params) {
    protSender.sendMakeCallRes(params);
    store.ringing = false;

    // 记录呼叫进入的分组，标识是被呼叫加入分组
    if (params.result == 0) {
      store.callGroupId = params.groupId;
    }
  };

  /**
   * 服务器呼叫被叫
   * @param {*} data 
   */
  onMakeCallReq(data) {
    let params = {
      callId: data.call_id,
      callerId: data.caller_id,
      callerName: data.caller_name,
      callerType: data.caller_type,
      groupId: data.group_id,
      extendInfo: data.extend_info
    };
    if (store.ringing) {
      logger.warn("Call " + store.callId + "is ringing!");
    } else {
      store.callId = data.call_id;
      store.ringing = true;
      eventRegistry.trigger("onIncommingCall", params);
    }
  }

  /**
   * 服务器通知已经收到呼叫请求，正在处理中
   * @param {*} data 
   */
  onMakeCallRes(data) {
    let params = {
      seqId: data.seq_id,
      calleeType: data.callee_type,
      calleeId: data.callee_id,
      callId: data.call_id
    };
    eventRegistry.trigger(EventType.EVENT_MAKE_CALL, 0, params);
  }

  /**
   * 服务器通呼叫结果
   * @param {*} data 
   */
  onCallResult(data) {
    let params = {
      callId: data.call_id,
      result: data.result,
      extendInfo: data.extend_info
    };
    eventRegistry.trigger("onCallResult", params);
  }

  /**
   * 服务器通知拆线
   * @param {*} data 
   */
  onCallReleaseReq(data) {
    let params = {
      callId: data.call_id,
      extendInfo: data.extend_info
    }

    if (data.call_id == store.callId) {
      if (!store.ringing && store.callGroupId) { // 强制退出分组
        rtcEngine.doLeave()
      }
      store.callId = null;
      store.ringing = false;
      store.callGroupId = null;
    }

    protSender.sendReleaseCallRes(data.call_id); // 自动应答
    eventRegistry.trigger("onCallRelease", params);
  }

  /**
   * 服务器通知取消呼叫
   * @param {*} data 
   */
  onCancelCallReq(data) {
    let params = {
      callId: data.call_id,
      extendInfo: data.extend_info
    }
    // 自动应答
    protSender.sendCancelCallRes(data.call_id)

    // 通知应用层处理
    eventRegistry.trigger("onCancelCall", params)
  }

  /**
   * 服务器响应取消呼叫
   * @param {*} data 
   */
  onCancelCallRes(data) {
    let params = {
      callId: data.call_id,
      result: data.result
    }
    if (data.result == 0) {
      eventRegistry.trigger(EventType.EVENT_CANCEL_CALL, 0, params);
    } else {
      eventRegistry.trigger(EventType.EVENT_CANCEL_CALL, 1, params);
    }
  }

  /**
   * 服务器通知结束呼叫
   * @param {*} data 
   */
  onFinishCallReq(data) {
    if (!store.callId || store.callId != data.call_id) {
      logger.error("Invalid callId: " + data.call_id + ", local callId: " + store.callId);
      return;
    }

    let params = {
      callId: data.call_id,
      extendInfo: data.extend_info
    }

    protSender.sendFinshCallRes(data.call_id)

    // 强制退出分组
    if (!store.ringing && store.callGroupId) {
      rtcEngine.doLeave()
    }

    store.callId = null;
    store.callGroupId = null;
    store.ringing = false;

    // 通知应用层处理
    eventRegistry.trigger("onFinishCall", params);
  }

  /**
   * 
   * @param {*} data 
   */
  onFinishCallRes(data) {
    let params = {
      callId: data.call_id,
      result: data.result
    }
    eventRegistry.trigger(EventType.EVENT_FINISH_CALL, 0, params);
  }
}

export default new OnlineManager();